<script>
import {mapState} from "vuex";

export default {
  name: "CardParticipants",
  data: () => ({
    dialog_vis_add_cofounders: false
  }),
  props: {
    edit_mode: Boolean,
    cofounders: Array,
    full_name_author: String
  },
  computed: {},
  methods: {
    inputCofounder(name_cofounder, index){
      this.$emit('inputCofounder', {
        name_cofounder: name_cofounder,
        index: index
      })
    },
    addVoidCofounder(){
      this.$emit('addVoidCofounder', {})
    },
    deleteNameCofounder(index){
      this.$emit('deleteNameCofounder', {index: index})
    }
  }
}
</script>

<template>
  <v-row no-gutters justify="center">
    <v-col cols="12" md="6">
      <v-row no-gutters>
        <v-col cols="3" md="1" class="d-flex justify-center align-center">
          <v-icon color="teal" size="35px">
            fa fa-user
          </v-icon>
        </v-col>
        <v-col cols="9" md="11">
          <v-card elevation="0">
            <v-card-subtitle>
              СОСТАВИТЕЛЬ ТЕХНОЛОГИЧЕСКОЙ КАРТЫ
            </v-card-subtitle>
            <v-card-text class="text-h5 text--primary">
              {{ full_name_author }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6">
      <v-row no-gutters>
        <v-col cols="3" md="1" class="d-flex justify-center align-center">
          <v-icon color="teal" size="35px">
            fa fa-users
          </v-icon>
        </v-col>
        <v-col cols="9" md="11">
          <v-card elevation="0">
            <v-card-subtitle>
              СОУЧРЕДИТЕЛИ
            </v-card-subtitle>
            <v-card-text class="text-h5 text--primary">
              <div v-for="(cofounder, index) in cofounders" :key="index">
                {{ cofounder }}
              </div>
              <v-btn
                  v-if="edit_mode"
                  @click="dialog_vis_add_cofounders = true"
                  elevation="0"
                  x-small
                  outlined
                  fab
                  color="teal"
              >
                <v-icon size="12px">
                  fa-plus
                </v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-dialog
        content-class="rounded-xl"
        v-model="dialog_vis_add_cofounders"
        width="600"
    >
      <v-card>
        <v-card-title>
          <v-row no-gutters>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                  icon
                  @click="dialog_vis_add_cofounders = false"
              >
                <v-icon size="20">
                  fa-times
                </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" class="d-flex justify-center text-h5">
              Добавление соучредителя
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <v-col class="ma-4" cols="8">
              <v-text-field
                  v-for="(cofounder, index) in cofounders" :key="index"
                  item-text="type_name"
                  :value="cofounder"
                  @input="inputCofounder($event, index)"
                  label="ФИО Участника"
                  hide-details
                  clearable
                  outlined
                  rounded
                  dense
              >
                <template v-slot:append-outer>
                  <v-btn
                      @click="deleteNameCofounder(index)"
                      elevation="0"
                      x-small
                      outlined
                      fab
                      color="red"
                  >
                    <v-icon size="12px">
                      fa-trash
                    </v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <div class="d-flex justify-center align-center">
            <v-btn
                @click="addVoidCofounder()"
                elevation="0"
                x-small
                outlined
                fab
                color="teal"
            >
              <v-icon size="12px">
                fa-plus
              </v-icon>
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
            <v-btn
                @click="dialog_vis_add_cofounders = false"
                elevation="0"
                class="rounded-xl"
                outlined
                color="teal"
            >
              Принять
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style scoped>

</style>